import { AssetManager } from 'components/sharpr/assetManager/AssetManager';
import { ApiResourcify } from 'components/sharpr/api/ApiResourcify.js';
import { ensure } from 'components/sharpr/ensure/ensure.js';
import moment from 'moment';

export function CurateSearchRoute($stateProvider) {
	'ngInject';
	$stateProvider.state('hub.loggedin.CurateSearch', {
		url: '/curate/search',
		controllerAs: 'vm',
		controller: CurateSearchCtrl,
		templateUrl: '/ng/hub/Curate/Search/CurateSearchCtrl.html?' + window.BUILD,
		resolve: {
			style: () => AssetManager.css('/ng/hub/Curate/Search/CurateSearchCtrl.css'),
			$title: () => 'Curate',
			feeds: ApiResourcify.endpoint('/curate/feeds'),
		},
	});
}

export class CurateSearchCtrl {
	constructor(Api, modal, feeds) {
		'ngInject';
		// save injections
		this.Api = Api;
		this.modal = modal;
		// save data
		this.feeds = ensure.array(feeds);
		// initial setup
		this.page = 1;
		this.posts = [];
		this.load();
	}

	async load() {
		this.isLoading = true;
		this.posts = [];
		const params = {
			term: this.term,
			feed_id: this.feedId,
			limit: 10,
			page: this.page,
		};
		const resp = await this.Api.getPaginated('/curate/search', params);
		this.posts = ensure.array(resp.data);
		this.numPages = resp.numPages;
		this.isLoading = false;
	}

	goToSource(post) {
		window.open(post.url, '_blank');
	}

	addPost(post) {
		const params = {
			heading: 'Curate post',
			width: 750,
			height: 647,
			locals: {
				mode: 'bookmarklet',
				fromCurate: true,
				imageChoices: post.image_src
					? [
							{
								src: post.image_src,
								width: post.image_width,
								height: post.image_height,
							},
					  ]
					: [],
				imageChosenIdx: 0,
			},
			onAfterInit: ctrl => {
				Object.assign(ctrl.post, {
					source_date: moment(post.source_date),
					headline: post.headline,
					rich_text_body: post.body,
					source_link: post.url,
				});
				setTimeout(() => {
					const textarea = document.querySelector('textarea.edit-headline');
					if (textarea && textarea.reinitAutosize) {
						textarea.reinitAutosize();
					}
				}, 150);
			},
		};
		const modal = this.modal.state('hub.loggedin.PostCreate', params);
		// TODO: mark post as curated if user actually adds post
	}

	markPostAsRead(post) {
		// set read date so post will get grayed out
		post.read_date = moment().format();
		// actually mark as read
		this.Api.post(`/curate/${post.id}/mark_read`);
	}
}
